class TableIconReplacer {
  constructor() {
    const bodyClassList = document.body.classList;
    const isPDF = bodyClassList.contains('pdf');
    const isWordPress = bodyClassList.contains('wordpress');

    if (!isPDF && !isWordPress) {
      console.warn('TableIconReplacer: Weder "pdf" noch "wordpress" Klasse auf <body> gefunden.');
      return;
    }

    this.symbols = {
      'symbol-1': { img: 'okay.png', alt: 'Ziel erreicht' },
      'symbol-2': { img: 'check.png', alt: 'Auf Zielkurs' },
      'symbol-3': { img: 'remove.png', alt: 'Nicht auf Zielkurs' },
      'symbol-4': { img: 'close.png', alt: 'Ziel nicht erreicht' },
    };

    const elements = [...document.querySelectorAll('.ally')];

    elements.forEach(el => {
      const text = el.textContent.trim(); // Extrahiert Text auch aus <p><span>
      const symbol = this.symbols[text];

      if (symbol) {
        this.changeSymbol(el, symbol.img, symbol.alt, isPDF);
      }
    });
  }

  changeSymbol(el, img, alt, isPDF) {
    const th = el.closest('td') || el.closest('th');
    if (!th) return;

    th.classList.add('ns-symbol-container');
    th.innerHTML = ''; // Alles im <td>/<th> löschen

    const symbolImage = document.createElement('img');
    const src = isPDF
      ? 'https://nswow-ld.nswow.ch/designs/bekb-ld/22.0.13/svg/' + img
      : window.location.origin + '/2025/app/themes/bekb-ar-theme/dist/images/' + img;

    symbolImage.setAttribute('src', src);
    symbolImage.setAttribute('alt', alt);
    symbolImage.setAttribute('title', 'Icon, ' + alt);
    symbolImage.setAttribute('class', 'ns-symbol');

    th.append(symbolImage);
  }
}

export default TableIconReplacer;
